export const BUSINESS_PRECEDENCE = [
  'Media Onsite',
  'Media Offsite',
  'Creative',
  'Consumer Insights',
  'Data',
  'Other',
];

export const PRODUCT_GROUP_PRECEDENCE = [
  'Web Homepage',
  'App',
  'Catalog',
  'Paid Social',
  'Display & Search',
  'Managed Service',
  'Self-Service',
  'Consulting',
  'Dashboards',
  'Creative services',
  'PBT',
  'Product View',
  'Tools',
  'Web Other',
  'Other',
];

const isIndexBefore = (list, left, right) => {
  const leftIndex = list.indexOf(left);
  const rightIndex = list.indexOf(right);
  return leftIndex === -1 ? false : leftIndex < rightIndex;
};

export default function getIndex(product, existingProducts) {
  // Find the existing candidate that the product should come before
  const successor = existingProducts.findIndex(candidate => {
    if (product.business !== candidate.business) {
      return isIndexBefore(
        BUSINESS_PRECEDENCE,
        product.business,
        candidate.business,
      );
    }

    if (product.productGroup !== candidate.productGroup) {
      return isIndexBefore(
        PRODUCT_GROUP_PRECEDENCE,
        product.productGroup,
        candidate.productGroup,
      );
    }

    return product.code < candidate.code;
  });
  // If no successor can be found, then the new quote line should be the last.
  return successor === -1 ? existingProducts.length : successor;
}
